import { createContext } from "react";

class LockSectionContext {
    isLocked = false;
}

export const LockContext: React.Context<LockSectionContext> = createContext(new LockSectionContext());